import { useChargingPoint } from '@services/device'
import useModal from '@shared/innmaxLib/hooks/useModal'
import { pathOr } from 'ramda'
import React from 'react'
import { useDashboardContext } from '../../Desktop/Provider'
import ParkingSpace from './ParkingSpace'
import ParkingSpaceDetailModal from './ParkingSpaceDetailModal'

const ParkingLotsView = () => {
  const { currentSession, lastUpdated, setParkingLotViewLoading } =
    useDashboardContext()
  const containerRef = React.useRef<HTMLDivElement>(null)

  const {
    open: openDetailModal,
    close: closeDetailModal,
    visible: visibleDetailModal,
    item: selectedChargingPoint,
  } = useModal()

  const { dataSource, refetch, isLoading } = useChargingPoint({
    sessionId: currentSession?.id,
    pageNum: 0,
    pageSize: 1000,
    deep: true,
  })

  React.useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0
      containerRef.current.scrollLeft = containerRef.current.scrollWidth
    }
  }, [dataSource])

  React.useEffect(() => {
    refetch()
  }, [lastUpdated])

  React.useEffect(() => {
    setParkingLotViewLoading?.(isLoading)
    return () => {
      setParkingLotViewLoading?.(false)
    }
  }, [isLoading])

  const chargingPointsBySessionName = React.useMemo(() => {
    if (!dataSource.content?.length) {
      return {}
    }
    const result = dataSource.content.reduce((acc, item) => {
      const sessionName = item.sessionName
      if (!acc[sessionName]) {
        acc[sessionName] = []
      }
      acc[sessionName].push(item)
      return acc
    }, {} as Record<string, typeof dataSource.content>)

    Object.keys(result).forEach(sessionName => {
      result[sessionName].sort((a: any, b: any) => {
        const aNumber = parseInt(a.displayName.split('E')[1], 10)
        const bNumber = parseInt(b.displayName.split('E')[1], 10)
        return aNumber - bNumber
      })
    })

    return result
  }, [dataSource])

  return isLoading ? null : (
    <div
      ref={containerRef}
      className="h-[calc(100vh-220px)] w-[98%] overflow-auto pt-100 pr-100 pl-150">
      <div className="flex flex-col justify-center items-end gap-60 w-max">
        {currentSession?.children?.map(lot => (
          <div key={lot.id}>
            <div className="text-3xl text-white fixed left-10 transform -translate-y-[40px]">
              {lot.name}
            </div>
            <div className="flex flex-row-reverse gap-10  w-max">
              {pathOr([], [lot.name], chargingPointsBySessionName).map(
                (chargingPoint, index) => (
                  <ParkingSpace
                    key={index}
                    data={chargingPoint}
                    onClick={() => {
                      openDetailModal(chargingPoint)
                    }}
                  />
                )
              )}
            </div>
          </div>
        ))}
      </div>
      {visibleDetailModal && selectedChargingPoint && (
        <ParkingSpaceDetailModal
          open={visibleDetailModal}
          onCancel={closeDetailModal}
          data={selectedChargingPoint}
        />
      )}
    </div>
  )
}

export default ParkingLotsView
